<!-- 流量中心-充值页 -->
<!-- 流量中心-充值页 -->
<template>
    <div class="stor" ref="basicInfo">
        <div class="stor-header cart-bg">
            <div class="header-title">余量管理</div>
            <div class="stor-header-content">
                <div>
                    <div>已使用（GB）</div>
                    <div>{{ ConsumeInfo.use }}</div>
                </div>
                <div>
                    <div>剩余（GB）</div>
                    <div class="color-red">{{ ConsumeInfo.remaining }}</div>
                </div>
            </div>
        </div>

        <div class="stor-buy cart-bg">
            <div class="header-title">套餐包购买</div>
            <div class="stor-buy-list">
                <div class="stor-buy-item" v-for="(item, index) in warpList" :key="index" @click="selectBuyItem(item)">
                    <div>{{ item.flow }}GB</div>
                    <div>每年每GB</div>
                    <div class="color-red">¥{{ CalculatePrice((item.price / item.flow).toFixed(2)) }}</div>
                    <div class="stor-buy-item-left">8折</div>
                    <!-- 选中✅icon -->
                    <div v-if="activeWarp.id == item.id" class="stor-buy-item-right">
                        <div class="stor-buy-item-right-bg"></div>
                        <div class="stor-buy-item-right-icon"><i class="el-icon-check"></i></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="ok-order cart-bg">
            <div>流量包类型：{{ activeWarp.flow }}GB 流量包</div>
            <div>流量单价：¥{{ CalculatePrice((activeWarp.price / activeWarp.storage).toFixed(2)) }}/GB</div>
            <div>购买后余量：{{ Number(ConsumeInfo.remaining) + Number(activeWarp.flow) }}GB</div>
            <div>支付金额：<span class="color-red">¥{{ activeWarp.price }}</span></div>
        </div>

        <div class="ok-buy cart-bg">
            <div class="ok-buy-top">
                <span>需支付：</span>
                <span class="color-red">¥{{ activeWarp.price }}</span>
                <div>(微信支付)</div>
            </div>
            <el-button class="ok-buy-bottom" type="primary" @click="getFuiyouUrl">确认购买</el-button>
        </div>

        <el-dialog title="扫码支付" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
            <span slot="footer" class="dialog-footer">
                <img :src="fuYouUrl"
                    alt="">
            </span>
        </el-dialog>
    </div>
</template>
<script>
import apis from '../../api/api'
export default {
    name: "storCenter",
    data() {
        return {
            buyList: [1, 2, 3],//套餐包购买列表
            enlargeTimeList: [1],//扩容时长列表
            ConsumeInfo: {},//余量管理
            warpList: [],//套餐包列表
            activeWarp: {},//当前选中的套餐包
            dialogVisible: false,//扫码支付弹窗
            fuYouUrl:'',//支付二维码
            outTradeNo:'',//订单号
            payCheckTimer: null // 用于保存轮询定时器
        }
    },
    mounted() {
        this.getConsumeInfo()
        this.getWarpList()//获取套餐包列表
    },
    methods: {
        getConsumeInfo() {//获取余量管理
            apis.ConsumeInfo({type:3}).then(res => {
                console.log('getConsumeInfo', res)
                this.ConsumeInfo = res;
            })
        },
        getWarpList() {//获取套餐包列表
            apis.getWarpList({type:3}).then(res => {
                console.log('getWarpList', res)
                this.warpList = res;
                this.activeWarp = this.warpList[0];
            })
        },
        CalculatePrice(num) {
            if (num == 'Infinity') {
                return '0.00';
            }
            return num
        },
        getFuiyouUrl() {//获取支付二维码
            apis.getFuiyouUrl({ plan_id: this.activeWarp.id }).then(res => {
                console.log('getFuiyouUrl', res)
                this.fuYouUrl = res.token_url;
                this.outTradeNo = res.trade_no;
                this.dialogVisible = true;//开启弹窗
                this.getPayBack()
            })
        },
        //获取支付回调
        getPayBack() {
            this.payCheckTimer = setInterval(() => {
                apis.checkPayOrder({ out_trade_no: this.outTradeNo }).then(res => {
                    console.log('支付状态:', res)
                    if (res.status == 1) {
                        this.$message.success('支付成功')
                        this.dialogVisible = false // 关闭弹窗
                        clearInterval(this.payCheckTimer) // 停止轮询
                        this.getConsumeInfo() // 刷新余量信息
                        console.log('清除定时器1');
                    }

                    if (res.status == 2) {
                        console.log('未支付');
                        // this.$message.error('支付失败')
                        // clearInterval(this.payCheckTimer)
                    }
                })
            }, 3000) // 每3秒查一次
        },
        //选择套餐包
        selectBuyItem(item) {
            console.log('选择套餐包', item)
            this.activeWarp = item;
        },
        //跳转购买记录
        goBuyLog() {
            console.log('跳转购买记录', this.staticPath)
            //    this.$router.push(this.staticPath + "material");
        },
        //关闭弹窗
        handleClose(done) {
            this.$confirm('确认放弃支付吗？')
                .then(_ => {
                    clearInterval(this.payCheckTimer) // 清除定时器
                    done();
                })
                .catch(_ => { });
        },
        //选择扩容时长
        selectEnlargeTimeItem(item) {
            console.log('选择扩容时长', item)
        },
        //确认购买跳转支付页面
        // goPay() {
        //     this.dialogVisible = true;//开启弹窗
        //     console.log('确认购买跳转支付页面')
        // }
    },
    beforeUnmount() {
        if (this.payCheckTimer) {
            console.log('清除定时器');
            clearInterval(this.payCheckTimer)
            this.payCheckTimer = null
        }
    },
}
</script>
<style scoped lang="less">
.stor-buy-log {
    padding: 30px 0;
    display: flex;
    align-items: center;
    color: blue;
    justify-content: flex-end;
    cursor: pointer;
}

.stor-header {

    .stor-header-content {
        display: flex;

        >div {
            margin-right: 40px;

            >:nth-child(1) {
                font-size: 14px;
                color: #606266;
                margin-bottom: 15px;
            }

            >:nth-child(2) {
                font-size: 14px;
                // background: rgb(245, 247, 250);
                color: rgb(69, 77, 83);
            }
        }
    }
}

.stor-buy {
    .stor-buy-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 30px;

        .stor-buy-item {
            width: 150px;
            height: 150px;
            background-color: #f0f0f0;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            cursor: pointer;

            >:nth-child(1) {
                margin-top: 25px;
                font-size: 16px;
                font-weight: 500;
            }

            >:nth-child(2) {
                font-size: 14px;
                color: #606266;
                margin: 15px 0;
            }

            .stor-buy-item-left {
                position: absolute;
                left: 0;
                top: 0;
                padding: 0 5px;
                background-color: #ffa326;
                color: #fff;
                font-size: 12px;
            }


        }
    }
}

.stor-buy-item-right {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;

    .stor-buy-item-right-bg {
        position: absolute;
        right: 0;
        top: 0;
        width: 0;
        height: 0;
        border-top: 25px solid blue;
        border-left: 25px solid transparent;
    }

    .stor-buy-item-right-icon {
        position: relative;
        z-index: 2;
        color: #fff;
        font-size: 12px;
        margin-right: 1px;
    }
}

.ok-order {
    display: flex;
    flex-direction: column;
    gap: 15px;
    font-size: 14px;
    color: #3c3c3c;
}

.ok-buy {
    .ok-buy-top {
        display: flex;
        align-items: center;
        font-size: 16px;

        span {
            font-weight: 600;
            color: #37383c;
        }

        div {
            margin-left: 5px;
            color: #0aa3ea;
        }
    }

    .ok-buy-bottom {
        cursor: pointer;
        display: inline-block;
        margin-top: 25px;
        padding: 10px 25px;
        background-color: #0aa3ea;
        color: #fff;
        font-size: 14px;
    }
}
.dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;

    >img {
        width: 200px;
        height: 200px;
    }
}


.font-w500 {
    font-weight: 500;
}

.font-size14 {
    font-size: 14px;
}

.font-size12 {
    font-size: 12px;
}

.font-size16 {
    font-size: 16px;
}

.color-8f8f {
    color: #8f8f8f;
}

.color-5c5c {
    color: #5c5c5c;
}

.color-red {
    color: red !important;
    font-weight: 500 !important;
}

.header-title {
    font-size: 16px;
    font-weight: 600;
    color: #37383c;
    line-height: 28px;
    margin-bottom: 20px;
}


.cart-bg {
    background-color: #f6f6f6;
    padding: 20px;
    position: relative;
    margin-bottom: 30px;
}
</style>